import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  section: { marginTop: theme.spacing(3) },
  note: {
    display: 'block',
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1)
  }
}))

export default useStyles
